var map = {
	"./all-products.json": "7c26",
	"./carousel.json": "5c11",
	"./cart.json": "622e",
	"./checkout.json": "1075",
	"./col.json": "55d7",
	"./container.json": "0aa8",
	"./feed.json": "1106",
	"./feeds.json": "e597",
	"./footer.json": "2092",
	"./image.json": "d34f",
	"./link.json": "e232",
	"./navbar.json": "0142",
	"./order-detail.json": "d13c",
	"./orders.json": "7ed1",
	"./product-detail.json": "e4de",
	"./products.json": "d5d0",
	"./row.json": "4dad",
	"./section.json": "3007",
	"./text-editor.json": "1aef",
	"./text.json": "b94e",
	"./video.json": "5782"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "55bc";